export class ServerError extends Error {
  private static NAME: string = 'ServerError'
  public static MESSAGE: string = 'Ops! Ocorreu um erro interno. Tente novamente em breve.'

  constructor(message?: string | null) {
    super(message ?? ServerError.MESSAGE)
    this.name = ServerError.NAME
  }
}
